(function () {
    'use strict';

    // 1st text input is to simulate required validation only
    // as soon as better approach will be found - it can be removed
    let component = {
        transclude: true,
        templateUrl:
            'app/js/components/controls/billwerk-date-time-picker-component/billwerk-date-time-picker.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmBDTP",
        bindings: {
            localDate: '=',
            ngRequired: '<',
            minDate: '<',
            maxDate: '<',
            showcleanbtn: '<',
            getDateToTimeAdjusted: "&?",
            isNowSelected: "=?",
            disabledNowButton: "<",
            ngModelChanged: '&?',
            showNowIfDateIsNull: '<'
        }
    };

    iteroComponents.component('billwerkDateTimePicker', component);

    controller.$inject = ['gettext', '$locale', 'PUtill', 'DatepickerUtils'];

    function controller(gettext, $locale, PUtill, DatepickerUtils) {
        let ctrl = this;

        let localDatePrevValue;
        let internalModelPrevValue;

        ctrl.$onInit = function () {
            DatepickerUtils.setOptions(ctrl);
            internalModelPrevValue = localDatePrevValue = ctrl.internalModel;
        };
        
        ctrl.$doCheck = function() {
            DatepickerUtils.turnMinAndMaxDateToBerlin(ctrl);
            ctrl.isNowSelected = isNowSelected();

            // something set directly using the datepicker
            if (!PUtill.areDatesEqual(internalModelPrevValue, ctrl.internalModel)) {
                internalModelPrevValue = new Date(ctrl.internalModel);
                
                if (!ctrl.isNowSelected && ctrl.internalModel) {
                    let internalDateString = PUtill.toShortDateString(ctrl.internalModel);
                    let internalMidnight = DatepickerUtils.parseBerlinDate(internalDateString);
                    
                    if (ctrl.getDateToTimeAdjusted){
                        let adjustedValue = ctrl.getDateToTimeAdjusted({ date: internalMidnight });
                        ctrl.localDate = adjustedValue;
                    } else
                        ctrl.localDate = DatepickerUtils.backToBrowserTimezone(internalMidnight);
                } else
                    ctrl.localDate = DatepickerUtils.backToBrowserTimezone(ctrl.internalModel);

                localDatePrevValue = new Date(ctrl.localDate);
                DatepickerUtils.markAsAlreadyInBrowserTimezone(localDatePrevValue);
                ctrl.internalModel = DatepickerUtils.adjustToDst(ctrl.localDate);
                internalModelPrevValue = new Date(ctrl.internalModel);

                if (ctrl.ngModelChanged)
                    ctrl.ngModelChanged();
            }

            // something set outside
            if (!PUtill.areDatesEqual(localDatePrevValue, ctrl.localDate)) {
                if (ctrl.localDate) {
                    localDatePrevValue = new Date(ctrl.localDate);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone(localDatePrevValue);
                    ctrl.internalModel = DatepickerUtils.adjustToDst(ctrl.localDate);
                    internalModelPrevValue = new Date(ctrl.internalModel);
                } else
                    internalModelPrevValue = localDatePrevValue = ctrl.internalModel = null;
            }
        };
        
        function isNowSelected() {
            let duration = momentsDuration(DatepickerUtils.backToBrowserTimezone(ctrl.internalModel), moment());
            let asSeconds = duration.asSeconds();

            return Math.abs(asSeconds) < 1;
        }
        
        function momentsDuration(date1, date2) {
            let date1Moment = moment(date1);
            let date2Moment = moment(date2);
            let duration = moment.duration(date1Moment.diff(date2Moment));
            return duration;
        }

        ctrl.getCurrentDate = function () {
            return new Date();
        }
        
        ctrl.getCurrentDatePlaceholder = function () {
            return DatepickerUtils.adjustToDst(ctrl.getCurrentDate());
        }

        DatepickerUtils.defineChangeEvent(ctrl);
        DatepickerUtils.defineOpen(ctrl);
        DatepickerUtils.defineDisabled(ctrl);
        DatepickerUtils.init(ctrl);
    }
})();
